const sessionKeys = ['user-token', 'user-id', 'user-category', 'user-data'];

function applyTokenSession(session, storage, redirect) {
  if (
    !session ||
    typeof session.token !== 'string' ||
    !session.token.trim() ||
    /\s/.test(session.token) ||
    !Number.isInteger(session.id) ||
    session.id <= 0 ||
    !['patient', 'psychologist'].includes(session.category) ||
    !session.user ||
    typeof session.user !== 'object' ||
    Array.isArray(session.user)
  ) {
    throw new Error('O acesso não corresponde a um perfil válido do Ondivan.');
  }

  const values = [
    session.token,
    String(session.id),
    session.category,
    JSON.stringify(session.user),
  ];
  const previousValues = sessionKeys.map((key) => storage.getItem(key));
  try {
    sessionKeys.forEach((key, index) => storage.setItem(key, values[index]));
    // A recarga também descarta os dados do usuário anterior mantidos em memória.
    redirect(session.category);
  } catch (error) {
    // Libere espaço antes de restaurar os valores anteriores em caso de quota excedida.
    sessionKeys.forEach((key) => storage.removeItem(key));
    sessionKeys.forEach((key, index) => {
      if (previousValues[index] !== null) {
        storage.setItem(key, previousValues[index]);
      }
    });
    throw new Error('Não foi possível trocar a sessão. Verifique o armazenamento do navegador.');
  }
}

export default function createTokenLogin({ getSession, storage, redirect }) {
  return async (token) => {
    if (typeof token !== 'string' || !token.trim() || /\s/.test(token.trim())) {
      throw new Error('Informe um token válido.');
    }

    const normalizedToken = token.trim();
    let session;
    try {
      session = await getSession(normalizedToken);
    } catch (error) {
      const detail = error.response && error.response.data && error.response.data.detail;
      // Não exponha o objeto de erro do Axios: ele contém o token nos headers.
      throw new Error(typeof detail === 'string' ? detail : 'Não foi possível validar o token.');
    }

    applyTokenSession({ ...session, token: normalizedToken }, storage, redirect);
  };
}
